import { Link, useLocation } from 'react-router-dom';

import { servicePages } from '@/content/servicePages';
import { getSeoRoute } from '@/lib/seo';

export default function ServiceDetailPage() {
  const { pathname } = useLocation();
  const service = servicePages[pathname];
  const seo = getSeoRoute(pathname);

  if (!service) return null;

  return (
    <div className="min-h-screen bg-cream-50">
      <section className="pt-32 md:pt-40">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 pb-14 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <p className="font-mono text-xs text-terracotta-600 tracking-[0.25em] uppercase mb-5">{service.eyebrow}</p>
            <h1 className="font-serif text-5xl md:text-7xl text-charcoal-900 leading-[0.95] mb-7">{seo.h1}</h1>
            <p className="text-lg md:text-xl text-stone-600 leading-relaxed max-w-2xl">{service.intro}</p>
          </div>
          <p className="lg:col-span-5 text-stone-600 leading-relaxed max-w-xl">{service.overview}</p>
        </div>
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
          <img src={service.image} alt={`${seo.h1} project example`} width="1600" height="900" fetchPriority="high" decoding="async" className="w-full aspect-[16/8] object-cover" />
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <p className="font-mono text-xs text-stone-400 tracking-[0.22em] uppercase mb-4">Scope</p>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal-900 mb-8">What we can coordinate</h2>
          <ul className="space-y-4">
            {service.scope.map((item) => <li key={item} className="flex gap-3 text-stone-700"><span className="text-terracotta-500">—</span>{item}</li>)}
          </ul>
        </div>
        <div className="lg:col-span-7 grid sm:grid-cols-2 border-t border-l border-stone-200">
          {service.process.map((step, index) => (
            <div key={step.title} className="p-7 md:p-9 border-r border-b border-stone-200">
              <span className="font-mono text-xs text-terracotta-500">0{index + 1}</span>
              <h3 className="font-serif text-2xl text-charcoal-900 mt-5 mb-3">{step.title}</h3>
              <p className="text-sm text-stone-600 leading-relaxed">{step.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-charcoal-900 text-cream-50 py-20">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 flex flex-col md:flex-row gap-8 items-start md:items-center justify-between">
          <div><p className="font-mono text-xs text-terracotta-400 tracking-[0.22em] uppercase mb-3">Relevant work</p><h2 className="font-serif text-3xl md:text-4xl">See the thinking in a real project.</h2></div>
          <div className="flex flex-wrap gap-3">
            <Link to={service.proof.path} className="px-6 py-3 border border-cream-50/30 hover:border-cream-50 transition-colors">{service.proof.label}</Link>
            <Link to="/contact" className="px-6 py-3 bg-terracotta-500 hover:bg-terracotta-600 transition-colors">Discuss your project</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
